import React, { ReactNode } from 'react';
import { observer } from 'mobx-react-lite';
import { useRouteModel } from './routeHooks';
import { DirectRouteState } from './directRouteState';

import { TRACE } from '../core/debug/debugMacros';

type Props = {
  children: ReactNode;
};

export const DirectRoute = observer((props: Props) => {
  const { children } = props;

  const model = useRouteModel((kernel) => new DirectRouteState(kernel.store));

  TRACE(model, `render()`, { props, model });

  return <>{children}</>;
});